import DialogContext from '@Contexts/dialogContext';
import { useContext } from 'react';

const useDialog = () => useContext(DialogContext);

export default useDialog;
